import "./TFDAccelerateEuropaLeague.css";

import { Link } from "react-router-dom";

export default function TFDAccelerateEuropaLeague() {
  return (
    <div className="tfd-accelerate-europa-page">
      {/* HERO SECTION */}
      <section className="tf-hero-europa">
        <div className="hero-image-wrap">
          <img
            src="/images/accelerate/europa-hero.jpg"
            alt="Europa League Hero"
            className="hero-bg-image"
          />
          <div className="overlay-dark" />
          <div className="hero-content themeflat-container">
            <h1 className="hero-title wow fadeInUp animated">
              Perth Europa League
            </h1>
            <p className="hero-subtitle wow fadeInUp animated">
              A premier competition for young talents in Perth.
            </p>
            <Link to="/contact" className="flat-button wow fadeInUp animated">
              Join the Action
            </Link>
          </div>
        </div>
      </section>

      {/* INFO SECTION */}
      <section className="tf-europa-info main-content">
        <div className="themeflat-container">
          <div className="row align-items-center">
            <div className="col-md-6 wow fadeInLeft animated">
              <div className="title-box title-small-v2">
                <span className="sub-title">High-Caliber Competition</span>
                <h2 className="title-section">Elevate Your Game</h2>
              </div>
              <p className="post">
                Perth Europa League brings the international spirit to local
                grounds, offering a structured and competitive environment for
                young players. Experience top-tier match intensity, skill
                development, and exposure to professional pathways.
              </p>
              <ul className="list-check">
                <li>
                  <strong>Competitive Matches:</strong> Engage in high-intensity
                  games.
                </li>
                <li>
                  <strong>Skill Enhancement:</strong> Improve technical and tactical
                  abilities.
                </li>
                <li>
                  <strong>Professional Standards:</strong> Well-organized tournaments
                  with experienced referees.
                </li>
                <li>
                  <strong>Pathways to Success:</strong> Opportunities for recognition
                  and growth.
                </li>
              </ul>
              <Link to="/contact" className="flat-button mt-3">
                Register Now
              </Link>
            </div>
            <div className="col-md-6 wow fadeInRight animated">
              <div className="image-wrapper">
                <img
                  src="/images/accelerate/europa-gallery.jpg"
                  alt="Europa League Gallery"
                  className="image-gr"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
